import api from '../api/axios';

export interface Task {
  id?: number;
  project: number;
  title: string;
  description?: string;
  assignedTo?: number;
  priority?: 'low' | 'medium' | 'high' | 'urgent';
  status?: 'todo' | 'inProgress' | 'review' | 'done' | 'blocked';
  startDate?: string;
  dueDate?: string;
  estimatedHours?: number;
  actualHours?: number;
  progress?: number;
}

const TaskService = {
  getAll: (params?: any) => api.get('/tasks', { params }),
  getOne: (id: number) => api.get(`/tasks/${id}`),
  create: (data: Task) => api.post('/tasks', { data }),
  update: (id: number, data: Partial<Task>) => api.put(`/tasks/${id}`, { data }),
  delete: (id: number) => api.delete(`/tasks/${id}`),
  getByProject: (projectId: number, params?: any) =>
    api.get('/tasks', {
      params: { ...params, 'filters[project][id][$eq]': projectId },
    }),
};

export default TaskService;

